import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import router from './router'
import BaiduMap from 'vue-baidu-map'
import animated from 'animate.css'
import IsPC from "./util/isPc.js";

Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: 'gb5XoAeqJYTSHQbCnOmTyZvOxHP8x3cu'
})

Vue.config.productionTip = false

Vue.use(animated)

Vue.use(ElementUI)

Vue.config.silent = true

Vue.prototype.$IsPc=IsPC;
router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
